// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('[truncate]', function(element) {
  const TRUNCATE_HEIGHT = 200 // if you change this, also change the corresponding value in blocks/truncate.scss

  const init = function() {
    if (needTruncation()) {
      registerButton()
    } else {
      expand()
    }
  }

  function registerButton() {
    const expandButton = element.querySelector('[toggle="truncate"]')
    expandButton.addEventListener('click', (event) => {
      event.preventDefault()
      expand()
    })
  }

  function needTruncation() {
    const truncateStyle = window.getComputedStyle(element.querySelector('.truncate--body'), null)
    return parseInt(truncateStyle.getPropertyValue('height')) >= TRUNCATE_HEIGHT
  }

  function expand() {
    element.classList.add('-expanded')
  }

  init()
})
